<template>
  <div class="row">
    <el-drawer
      title=""
      :visible.sync="viewChargesSummary"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <online-booking-fee-charge-summary :charges_summary="charges_summary"></online-booking-fee-charge-summary>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showForm"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <online-booking-fee-form
            @save="getOnlineBookingFees()"
            v-if="showForm"
            :online_booking_fee="selected"
          ></online-booking-fee-form>
        </div>
      </div>
    </el-drawer>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Manage Online Booking Fees</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page"
            size="small"
          >
            <el-option
              class="select-default"
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            size="small"
            class="ml-2"
            @click="handleForm"
            >New +</el-button
          >
          <el-button
            type="primary"
            size="small"
            class="ml-2"
            @click="handleViewChargesSummary"
            >View Charges Summary</el-button
          >
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="term"
              addon-right-icon="nc-icon nc-zoom-split"
            >
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            header-row-class-name="text-primary"
            :data="online_booking_fees"
            style="width: 100%"
          >
            <el-table-column
              :min-width="170"
              class-name="td-actions"
              label="Route"
            >
              <template slot-scope="props">
                <div>{{ props.row.route ? props.row.route.code : "n/a" }}</div>
              </template>
            </el-table-column>

            <el-table-column
              :min-width="80"
              class-name="td-actions"
              label="Service Charge (%)"
            >
              <template slot-scope="props">
                <div>{{ props.row.service_fee }} %</div>
              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="Additional Charge (Fixed)"
            >
              <template slot-scope="props">
                {{ money(props.row.additional_charge) }}
              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="Start Date"
            >
              <template slot-scope="props">
                {{ dateLabel(props.row.start_date) }}
              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="Passengers"
            >
              <template slot-scope="props">
                {{ props.row.passenger_types }}
              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="STATUS"
            >
              <template slot-scope="props">
                {{ props.row.status == 1 ? "ACTIVE" : "INACTIVE" }}
              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="Actions"
            >
              <template slot-scope="props">
                <el-button
                  type="default"
                  link
                  @click="handleEdit(props.row)"
                  size="mini"
                >
                  <i class="fa fa-edit"></i>
                </el-button>
                <confirm-delete
                  @onClick="handleDelete(props.row)"
                  :label="'Delete'"
                ></confirm-delete>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          >
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OnlineBookingFeeForm from "./OnlineBookingFeeForm.vue";
import { OnlineBookingFee } from "../../../../resources/online_booking_fee";
import ConfirmDelete from "../../../Common/ConfirmDelete.vue";
import OnlineBookingFeeChargeSummary from "./OnlineBookingFeeChargeSummary.vue";

export default {
  components: {
    ConfirmDelete,
    OnlineBookingFeeForm,
    OnlineBookingFeeChargeSummary
  },
  data() {
    return {
      showDelete: false,
      showForm: false,
      online_booking_fees: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 15,
        currentPage: 1,
        total: 0,
      },
      term: null,
      viewChargesSummary: false,
      charges_summary: [],
    };
  },
  watch: {
    term: function () {
      if (!this.term || this.term.length > 2) {
        this.getOnlineBookingFees();
      }
    },
    "pagination.perPage": function () {
      if (this.pagination.currentPage == 1) {
        this.getOnlineBookingFees();
      } else {
        this.pagination.currentPage = 1;
      }
    },
    "pagination.currentPage": function () {
      this.getOnlineBookingFees();
    },
  },
  created: function () {
    this.getOnlineBookingFees();
  },
  methods: {
    handleViewChargesSummary() {
      this.viewChargesSummary = true;
    },
    dateLabel(date) {
      return this.$moment(date).format("MMM DD, YYYY");
    },
    handleEdit(model) {
      this.showForm = true;
      this.selected = Object.assign({}, model);
    },
    handleClose() {
      this.showDelete = false;
      this.showForm = false;
      this.viewChargesSummary = false;
    },
    handleForm() {
      this.showForm = true;
      this.selected = null;
    },
    handleDelete(model) {
      this.$loading = true;
      this.$loadingText = "Removing";

      OnlineBookingFee.delete({
        id: model.id,
      })
        .then((result) => {
          this.$notify({
            type: "success",
            title: "Success",
            text: "Fee has been removed",
          });
          this.getOnlineBookingFees();
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },
    getOnlineBookingFees() {
      this.handleClose();
      let params = {
        term: this.term,
        status: this.status,
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
      };
      this.$loading = true;
      OnlineBookingFee.get({
        params: params,
      })
        .then((result) => {
          this.charges_summary = result.data?.charges_summary || [];
          if (result.data.online_booking_fees)
            this.online_booking_fees = result.data.online_booking_fees;
        })
        .catch(() => {
          this.$notify({
            type: "danger",
            title: "Error",
            text: "Unable to fetch fees",
          });
        })
        .finally(() => {
          this.$loading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
